import { javantApi } from "../constants";

export const GameItemPageService = {
    getAppsByCategory(category, platform){
        return javantApi.get(`component/app/apps?category=${category}&platform=${platform}`); 
    },
}